import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService, UserService } from '@meddatacore/shared';

@Component({
  selector: 'app-set-password-modal',
  templateUrl: './set-password-modal.component.html',
  styleUrls: ['./set-password-modal.component.scss']
})
export class SetPasswordModalComponent implements OnInit {
  isLoading = false;
  changePasswordForm: FormGroup;
  constructor(public dialogRef: MatDialogRef<SetPasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private userService: UserService,
    private ntf: NotificationService,
    private formBuilder: FormBuilder
  ) {

  }

  ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      userId: [this.data.userId, Validators.required],
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', [Validators.required, this.confirmPasswordValidator.bind(this)]]
    });
  }
  confirmPasswordValidator(control: FormControl) {
    if (this.changePasswordForm) {
      if (control.value !== this.changePasswordForm.get('newPassword').value) {
        return { 'noMatch': true };
      }
      return null;
    } else {
      return { 'noMatch': true };
    }
  }
  setPassword() {
    this.isLoading = true;
    this.userService.setPassword(this.changePasswordForm.value).subscribe({
      next: () => {
        this.ntf.showSuccessUpdate();
        this.dialogRef.close({ success: true, password: this.changePasswordForm.get('newPassword').value });
      },
      error: (e: Error) => {
        this.ntf.showNotification(e.message);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }
}
